import { Container } from "reactstrap";

import FloatingToolbarForDeletedRecords from "./FloatingToolbarForDeletedRecords";
import AppPageHeader from "../../components/Headers/AppPageHeader";
import AppHelmet from "../../components/AppComponents/AppHelmet";
import CustomTableLayout from "../CustomTableLayout";
import useModule from "../../hooks/useModule";

const mainLayout = {
  id: "1",
  Fields: [
    "Name",
    "DeletionDate",
    "DataSource",
    "RecordData",
    "Created",
    "CreatedBy",
  ],
  ModuleAPIName: "DeletedRecords",
  Type: "Table",
};

const query = {
  _SelectedLayout: "1",
  Fields: [
    "Name",
    "DeletionDate",
    "DataSource",
    "RecordData",
    "Created",
    "CreatedBy",
  ],
  Filters: [],
  OrderBy: {
    Field: "DeletionDate",
    Direction: "DESC",
  },
  Pagination: {
    Count: 25,
    Page: 1,
  },
};

const DeletedRecords = () => {
  const { module } = useModule("DeletedRecords");

  if (!module) return null;

  return (
    <>
      <AppHelmet title="Recycle Bin Center - GrowthCloud.com" />
      <Container fluid>
        <div className="header">
          <div className="header-body">
            <AppPageHeader
              borderless={true}
              title="Recycle Bin Center"
              description="Manage deleted records in this Cloud"
            />
          </div>
        </div>
        <div className="mt--4">
          <CustomTableLayout
            title=""
            description=""
            module={module}
            recordNameField=""
            onOpenRecordName={(data) => {}}
            layout={mainLayout}
            initialQuery={query}
            SelectRecordsActions={FloatingToolbarForDeletedRecords}
          />
        </div>
      </Container>
    </>
  );
};

export default DeletedRecords;
